var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"80%"},attrs:{"id":"pie1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }